export default __webpack_public_path__ + "images/e699461a1f42452be5e24bff2325005e-video-playing.svg";